import { routeToPageMap } from './pages';

const siteName = 'Flexbox Patterns';

export default function titleReducer(state, action) {
  let pageName;
  const page = routeToPageMap[action.type];

  if (page) {
    pageName = page.name;
  } else {
    pageName = 'Page not found';
  }

  return `${siteName} - ${pageName}`;
}



// WEBPACK FOOTER //
// ./application/store/titleReducer.js